import script from "./BalTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./BalTooltip.vue?vue&type=style&index=0&id=2c9d43fb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9d43fb"]])

export default __exports__